export default __webpack_public_path__ + "static/media/Flag of Turks and Caicos Islands.68f878fd.gif";